import NumInput from './NumInput'

export default NumInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/NumInput/index.js